import {Component, ElementRef, OnInit, ViewChild, ViewEncapsulation} from '@angular/core';
import {ContentResponse} from "../../interface/contentResponse";
import {ContentService} from "../../service/content.service";
import {FormGroup} from "@angular/forms";
import {MatMenuTrigger} from "@angular/material/menu";
import {ContentType} from "../../interface/contentType";
import {catchError, forkJoin, mergeMap, of} from "rxjs";
import {MatDialog,  MatDialogRef} from "@angular/material/dialog";
import {AddContentModalComponent} from "../add-content-modal/add-content-modal.component";
import {ConfigUtility} from "../../utilityClass/configUtility";

@Component({
  selector: 'app-content',
  templateUrl: './content.component.html',
  styleUrls: ['./content.component.scss', '../../admin-page/admin-page.component.scss'],
  encapsulation: ViewEncapsulation.None
})
export class ContentComponent implements OnInit {
  contentTypesList: any
  content: ContentResponse[] = [];
  contentForm!: FormGroup;
  message: string | undefined;
  @ViewChild('fileInput')
  inputRef: ElementRef | any;
  imageUrl: any;
  showGridList: boolean = false;
  @ViewChild('menuTrigger') menuTrigger: MatMenuTrigger | undefined;
  selectedFile: File | null = null;
  showDashboard: boolean = true;
  socialMediaContent: ContentResponse[] = [];
  paymentContent: ContentResponse[] = [];
  contactContent: ContentResponse[] = [];
  documentContent: ContentResponse[] = [];
  businessContent: ContentResponse[] = [];
  showAddButton = true;
  showMoreContact: boolean = false;
  showMoreSocialMedia: boolean = false;
  showMorePayment: boolean = false;
  showMoreDocument: boolean = false;
  showMoreBusiness: boolean = false;
  private readonly maxFileSize = 2;
  dialogRef: MatDialogRef<AddContentModalComponent> | undefined;

  constructor(private contentService: ContentService,
              private dialog: MatDialog,
              private configUtility: ConfigUtility) {
  }

  ngOnInit() {
    this.loadContent();
    this.contentService.updatedContent.subscribe(response => {
        this.loadContent()
    })
  }

  openAddContent() {
    this.dialogRef = this.dialog.open(AddContentModalComponent, this.configUtility.getDialogConfig());
    this.dialogRef.afterClosed().subscribe((result: ContentResponse) => {
      if (result) {
        this.loadContent()
      }
    })
  }

  private filterContentByType(contentType: ContentType): ContentResponse[] {
    return this.content.filter((content) => content.contentType === contentType);
  }

  private handleFileUpload(contentId: bigint) {
    if (this.selectedFile) {
      this.contentService.uploadContentIcon(contentId, this.selectedFile).subscribe(
        () => {
          this.handleUploadSuccess();
        },
        (uploadError) => {
          console.error("Error uploading content icon ", uploadError);
        }
      );
    } else {
      this.handleUploadSuccess();
    }
  }

  private handleUploadSuccess() {
    this.showGridList = false;
    this.loadContent();
    this.contentForm.reset();
    this.imageUrl = null;
    this.showDashboard = true;
  }

  private loadContent() {
    this.contentService.getAllContent().subscribe((contents) => {
      this.content = contents;
      this.socialMediaContent = this.filterContentByType(ContentType.SOCIAL_MEDIA);
      this.paymentContent = this.filterContentByType(ContentType.PAYMENT);
      this.contactContent = this.filterContentByType(ContentType.CONTACT);
      this.documentContent = this.filterContentByType(ContentType.DOCUMENT);
      this.businessContent = this.filterContentByType(ContentType.BUSINESS);
      this.contentTypesList = [
        { type: 'Contact', content: this.contactContent, showMore: this.showMoreContact },
        { type: 'Social Media', content: this.socialMediaContent, showMore: this.showMoreSocialMedia },
        { type: 'Payment', content: this.paymentContent, showMore: this.showMorePayment },
        { type: 'Document', content: this.documentContent, showMore: this.showMoreDocument },
        { type: 'Business', content: this.businessContent, showMore: this.showMoreBusiness }
      ];
    });
  }

}
